export default "__VITE_ASSET__DBOMSzrM__"